import { render, staticRenderFns } from "./channelinventorylist.vue?vue&type=template&id=69b9cc76&scoped=true"
import script from "./channelinventorylist.vue?vue&type=script&lang=js"
export * from "./channelinventorylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b9cc76",
  null
  
)

export default component.exports